module.exports = __webpack_public_path__ + "img/resource-gray.svg";